import React from 'react';
import { type IconName } from './icon-name';

interface IconProps {
  name: IconName;
  className?: string;
  size?: number | string;
  alt?: string;
}

export const Icon: React.FC<IconProps> = ({
  name,
  className = '',
  size = 16,
  alt,
}) => {
  // Remove .svg extension if provided, then add it back
  const iconName = name.endsWith('.svg') ? name : `${name}.svg`;
  const iconPath = `/themes/custom/project/images/icons/${iconName}`;

  return (
    <img
      src={iconPath}
      alt={alt || `${name} icon`}
      width={size}
      height={size}
      style={{
        maxWidth: size,
        maxHeight: size,
      }}
      className={className}
    />
  );
};

export default Icon;
